import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import notyet from "../../assets/img/icons/notarticle.svg";
import active_check from "../../svg/verifiedCheck.svg";
import pfp from "../../assets/img/icons/default_pfp.png";
import alertSvg from "../../assets/img/icons/alert_info.svg";
import grant from "../../assets/img/icons/grant.svg";
import active_info from "../../svg/active-info.svg";
import Dropdown from "react-bootstrap/Dropdown";
import dots from "../../assets/img/icons/dots.svg";
import downloadBlue from "../../assets/img/icons/downloadBlue.svg";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { getDateFormat, downLoadFile, getNameFromUrl } from "../../utils";
import { useDispatch } from "react-redux";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import axios from "axios";
import Confetti from "react-confetti";
import { SERVER_URL } from "../../config";
import correct from "../../assets/img/icons/correct.png";

import {
  getAllGrants,
  getGrantsDetails,
  applyForGrant,
  getGrantsDetailsByName,
  acceptRejectArticle,
  deleteArticleById,
  reuploadArticle,
} from "../../store/apiCalls/dashboard";
import { FetchSimiilarityReport } from "../../containers/autherFlow/submitArticle/queries";
import { toast } from "react-toastify";
import RequestAmmended from "../Modal/RequestAmmended";
import UpdateArticleRequest from "../Modal/UpdateArticleRequest";
import ReasonModal from "../../containers/autherFlow/prdashboard/ReasonModal";
import NeedHelpModal from "../Modal/NeedHelpModal";

const ArticleListing = ({
  articleData,
  activeTab,
  totalRecords,
  fetchArticleData,
  setUpdateTrigger,
  setAmendmentUpdateTrigger,
}) => {
  console.log(articleData, "---");
  const navigate = useNavigate();
  const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
  const { userId } = jwt_decode(localStorage.usertoken);
  const dispatch = useDispatch();
  const limit = 20;
  const [nationality, setNationality] = useState("");
  const [articleId, setArticleId] = useState("");
  const [amendmentData, setAmendmentData] = useState("");
  const [noMoreAmendment, setNoMoreAmendment] = useState(false);
  const isDocUploadFailed = (art) => {
    if (!art) return false;
    return (
      art.documentUploadFailed === true ||
      art.isDocumentUploadFailed === true ||
      art.isExtractionFailed === true ||
      art.article?.[0]?.documentUploadFailed === true ||
      art.article?.[0]?.isDocumentUploadFailed === true ||
      art.title === "Please upload the article manuscript here to complete the submission process" ||
      art.title === "Please upload the article here to complete the submission process" ||
      art.article?.[0]?.title === "Please upload the article manuscript here to complete the submission process" ||
      art.article?.[0]?.title === "Please upload the article here to complete the submission process" ||
      (typeof art.title === "string" && art.title.includes("Please upload the article")) ||
      (typeof art.article?.[0]?.title === "string" && art.article?.[0]?.title.includes("Please upload the article"))
    );
  };

  const isArticleSubmitted = (art) => {
    if (!art) return false;
    const status = art.status || art.article?.[0]?.status;
    const stage = art.stage || art.article?.[0]?.stage;
    const articleStatus = art.articleStatus || art.article?.[0]?.articleStatus;
    const plagirismCheck = art.plagirismCheck || art.article?.[0]?.plagirismCheck;

    if (status === "submit") return true;
    if (stage === "submitted" || stage === "adminctrl") return true;
    if (
      articleStatus === "Waiting for Similarity Check by Admin" ||
      articleStatus === "Submitted" ||
      articleStatus === "Pending System Verification" ||
      (typeof articleStatus === "string" && articleStatus.toLowerCase().includes("submitted"))
    ) return true;
    if (plagirismCheck === "underProcess" || plagirismCheck === "Done" || plagirismCheck === "done") return true;

    return false;
  };

  const isSocietyJournalArticle = (art) => {
    if (!art) return false;
    const jType = art?.submissionDetail?.journalType || art?.journalType;
    const jTypeId = typeof jType === "object" ? jType?._id : jType;
    const jTypeName = typeof jType === "object" ? jType?.journalType : (typeof jType === "string" ? jType : "");
    const directJType = typeof art?.journalType === "object" ? art?.journalType?._id : art?.journalType;
    const jName = (art?.submissionDetail?.journalName || art?.journalName || "").trim().toLowerCase();

    return (
      jTypeId === "6454a6390d88e62fa10503bf" ||
      directJType === "6454a6390d88e62fa10503bf" ||
      jTypeName === "Society Journal" ||
      directJType === "Society Journal" ||
      art?.journaldstype === "societyArticle" ||
      art?.paymentBySociety?.apcPayBySociety === true ||
      jName === "applied and basic obesity, diabetes and endocrinology" ||
      jName === "applied and basic obesity, diabetes and endocrinology journal" ||
      jName.includes("applied and basic obesity")
    );
  };

  const isMegaJournalArticle = (art) => {
    if (!art) return false;
    return !isSocietyJournalArticle(art);
  };

  const isBlankMegaArticle = (art, isMega) => {
    if (!art) return false;
    const isMegaJ = isMega !== undefined ? isMega : isMegaJournalArticle(art);
    if (!isMegaJ) return false;
    const rawTitle = art?.title || art?.article?.[0]?.title || "";
    const cleanTitle = typeof rawTitle === "string" ? rawTitle.trim() : "";

    return (
      isDocUploadFailed(art) ||
      !cleanTitle ||
      cleanTitle === "Please upload the article manuscript here to complete the submission process" ||
      cleanTitle === "Please upload the article here to complete the submission process" ||
      cleanTitle.includes("Please upload the article")
    );
  };

  const hasTitleAndDescription = (art) => {
    if (!art) return false;
    const rawTitle = art?.title || art?.article?.[0]?.title;
    const title = typeof rawTitle === "string" ? rawTitle.trim() : "";
    const hasTitle = Boolean(
      title &&
      title !== "Not started" &&
      !title.toLowerCase().includes("please upload the article")
    );

    const rawDesc =
      art?.abstract ||
      art?.description ||
      art?.article?.[0]?.abstract ||
      art?.article?.[0]?.description;
    const cleanDesc =
      typeof rawDesc === "string"
        ? rawDesc.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim()
        : "";
    const hasDesc = Boolean(cleanDesc && cleanDesc !== "Not started");

    return hasTitle && hasDesc;
  };

  const isBlankSocietyArticle = (art, isSociety) => {
    if (!art) return false;
    if (hasTitleAndDescription(art)) return false;
    const isSoc =
      isSociety !== undefined
        ? isSociety
        : (
          art?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
          art?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
          art?.journaldstype === "societyArticle" ||
          art?.submissionDetail?.journalType?.journalType === "Society Journal" ||
          art?.paymentBySociety?.apcPayBySociety === true ||
          isSocietyJournalArticle(art)
        );
    if (!isSoc) return false;

    const draftTitle = art?.title;
    if (draftTitle === undefined || draftTitle === null) return true;
    if (typeof draftTitle === "string") {
      const clean = draftTitle.trim();
      if (!clean || clean === "Not started" || clean.toLowerCase().includes("please upload the article")) {
        return true;
      }
    }

    const rawTitle = art?.title || art?.article?.[0]?.title;
    if (!rawTitle) return true;
    if (typeof rawTitle !== "string") return true;
    const cleanTitle = rawTitle.trim();
    if (!cleanTitle || cleanTitle === "Not started") return true;
    if (cleanTitle.toLowerCase().includes("please upload the article")) return true;

    return false;
  };

  const isRealArticle = (art) => {
    if (!art) return false;
    // Only apply real article check to Mega Journal; keep Society Journal as it is
    if (isSocietyJournalArticle(art)) return true;

    if (isDocUploadFailed(art)) return false;
    if (isBlankMegaArticle(art)) return false;

    const rawTitle = art?.title || art?.article?.[0]?.title;
    if (typeof rawTitle !== "string") return false;
    const cleanTitle = rawTitle.trim();
    if (!cleanTitle) return false;
    if (cleanTitle === "Not started") return false;
    if (cleanTitle.toLowerCase().includes("please upload the article")) return false;

    return true;
  };

  const [showBlankMegaUploadModal, setShowBlankMegaUploadModal] = useState(false);
  const [blankMegaSelectedArticle, setBlankMegaSelectedArticle] = useState(null);

  const handleOpenBlankMegaUpload = (art) => {
    setBlankMegaSelectedArticle(art);
    setShowBlankMegaUploadModal(true);
  };

  const [showNotAccepted, setShowNotAccepted] = useState(false);
  const [reasonComments, setReasonComments] = useState("");
  const [revokeComments, setRevokeComments] = useState("");
  const [showReject, setShowReject] = useState(false);
  const [reasonHandle, setReasonHandle] = useState("");
  const [rejectionArticleId, setRejectionArticleId] = useState("");
  const [articleName, setArticleName] = useState("");
  const [prReviewReport, setPrReviewReport] = useState({});
  const [reason, setReason] = useState({});
  const [authorName, setAuthorName] = useState("");
  const [amendmentArticleId, setAmendmentArticleId] = useState("");
  const [journalName, setJournalName] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [articleUpdateRequest, setArticleUpdateRequest] = useState(false);
  const [articleUpdateNewVersion, setArticleUpdateNewVersion] = useState(false);
  const [show, setShow] = useState(false);
  const [received, setReceived] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showWorkSaved, setShowWorkSaved] = useState({
    articleId: "",
    PID: "",
    status: "",
    finalPayment: "",
  });

  console.log(showWorkSaved);

  const [amendmentPopup, setamendmentPopup] = useState(false);
  const [amendmentSharingPopup, setamendmentSharingPopup] = useState(false);
  const [updateArticlePopup, setUpdateArticlePopup] = useState(false);
  const [updateSharingPopup, setUpdateSharingPopup] = useState(false);
  const [alreadyUpdatedPopup, setAlreadyUpdatedPopup] = useState(false);
  const [showNewArticleRequest, setShowNewArticleRequest] = useState(false);
  const [fundingStatus, setFundingStatus] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [articleToDeleteId, setArticleToDeleteId] = useState("");

  const handleShow = () => setShow(true);
  const [page, setPage] = useState(1);
  const [wordDecCount, setWordDecCount] = useState(0);
  const [showReadMore, setShowReadMore] = useState([]);
  const [grantDetail, setGrantDetail] = useState([]);
  const [availableGrants, setavailableGrants] = useState(false);
  const [grantData, setGrantData] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [acceptedRevisionIds, setAcceptedRevisionIds] = useState([]);
  const handleClose = () => setShowDetail(false);
  const MAX_WORDS = 30;
  const [applyGrant, setapplyGrant] = useState(false);
  const [formData, setFormData] = useState({
    proposal: "",
    foundReceived: false,
  });
  const [formErrors, setFormErrors] = useState({
    proposal: "",
  });
  const [articleDetailData, setArticleDetailData] = useState({
    articleId: "",
    applicantName: "",
    article: "",
  });

  const sucessHandlerSimillarityReport = (articleDetails) => {
    if (articleDetails.status === 200) {
      downLoadFile(articleDetails.data.url, "report.pdf");
    }
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const { mutate: downloadSimiliratyReport } = FetchSimiilarityReport(
    sucessHandlerSimillarityReport
  );
  const wordLimit = 300;

  const handleReuploadArticle = async (art) => {
    const articleId = typeof art === "object" ? (art?._id || art?.article?.[0]?._id) : art;
    const isSociety =
      typeof art === "object" &&
      (art?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
        art?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
        art?.journaldstype === "societyArticle" ||
        art?.submissionDetail?.journalType?.journalType === "Society Journal");

    const targetPath = isSociety
      ? `/dashboard/society-editor/${articleId}/edit-article`
      : `/dashboard/edit-article/${articleId}`;

    dispatch({ type: "SET_LOADER", payload: true });
    try {
      const response = await reuploadArticle(headers, { articleId });
      dispatch({ type: "SET_LOADER", payload: false });
      if (response?.status === 200 && (response?.data?.success || response?.data?.data?.success)) {
        toast.success(
          response?.data?.message ||
          response?.data?.data?.message ||
          "Article reset for reupload. You can now re-edit and resubmit."
        );
        sessionStorage.setItem("reupload_article_triggered", "true");
        navigate(targetPath, { state: { openUploadModal: true } });
      } else {
        toast.error(
          response?.data?.message ||
          response?.data?.data?.message ||
          "Failed to process reupload"
        );
      }
    } catch (error) {
      dispatch({ type: "SET_LOADER", payload: false });
      console.error("Error reuploading article:", error);
      toast.error("Failed to process reupload");
    }
  };

  const fetchAllGrantsData = () => {
    dispatch({ type: "SET_LOADER", payload: true });
    const fetchdata = async () => {
      const params = {
        status: "live",
        page: page,
        limit: limit,
      };
      return getAllGrants(headers, params);
    };

    fetchdata()
      .then((grantData) => {
        if (grantData.status === 200 && grantData?.data?.data) {
          dispatch({ type: "SET_LOADER", payload: false });
          setGrantData(grantData.data.data);
        }
      })
      .catch((err) => console.log(err));
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const getGrantDetailReceived = (name) => {
    dispatch({ type: "SET_LOADER", payload: true });
    const fetchdata = async () => {
      const params = {
        grantName: name,
      };
      return getGrantsDetailsByName(headers, params);
    };

    fetchdata()
      .then((grantDetailData) => {
        if (grantDetailData.status === 200 && grantDetailData?.data?.data) {
          dispatch({ type: "SET_LOADER", payload: false });
          setGrantDetail(grantDetailData?.data?.data);
          setReceived(true);
        }
      })
      .catch((err) => console.log(err));
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const getGrantDetailByName = (name) => {
    dispatch({ type: "SET_LOADER", payload: true });
    const fetchdata = async () => {
      const params = {
        grantName: name,
      };
      return getGrantsDetailsByName(headers, params);
    };

    fetchdata()
      .then((grantDetailData) => {
        if (grantDetailData.status === 200 && grantDetailData?.data?.data) {
          dispatch({ type: "SET_LOADER", payload: false });
          setGrantDetail(grantDetailData?.data?.data);
          setShowDetail(true);
          setShowButton(false);
        }
      })
      .catch((err) => console.log(err));
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const getGrantDetail = (id) => {
    dispatch({ type: "SET_LOADER", payload: true });
    const fetchdata = async () => {
      const params = {
        grantId: id,
      };
      return getGrantsDetails(headers, params);
    };

    fetchdata()
      .then((grantDetailData) => {
        if (grantDetailData.status === 200 && grantDetailData?.data?.data) {
          dispatch({ type: "SET_LOADER", payload: false });
          setGrantDetail(grantDetailData?.data?.data);
          setavailableGrants(false);
          setShowDetail(true);
        }
      })
      .catch((err) => console.log(err));
    dispatch({ type: "SET_LOADER", payload: false });
  };
  const applyForGrants = (formData) => {
    dispatch({ type: "SET_LOADER", payload: true });
    const fetchdata = async () => {
      const params = {
        articleId: articleDetailData?.articleId,
        grantName: grantDetail?.grantName,
        grantId: grantDetail?._id,
        applicantName: articleDetailData?.applicantName,
        article: articleDetailData?.article,
        grantValue: grantDetail?.grantValue,
        proposal: formData?.proposal,
        fundindRecevied: formData?.foundReceived,
      };
      return applyForGrant(headers, params);
    };

    fetchdata()
      .then((grantApplyData) => {
        if (grantApplyData?.data?.sucess === true) {
          dispatch({ type: "SET_LOADER", payload: false });
          setapplyGrant(false);
          setShow(true);
        }
      })
      .catch((err) => console.log(err));
    dispatch({ type: "SET_LOADER", payload: false });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      setFundingStatus("");
      applyForGrants(formData);
    }
  };
  const validateForm = () => {
    let valid = true;
    const errors = {};
    if (!formData?.proposal) {
      errors.proposal = "This field is required";
      valid = false;
    } else if (formData.proposal.split(" ").length > wordLimit) {
      errors.proposal = `Description should not exceed ${wordLimit} words`;
      valid = false;
    }
    setFormErrors(errors);
    return valid;
  };
  const handleChangeCheckbox = (event) => {
    const { name, checked } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };
  const handleChangeProposal = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setWordDecCount(value.trim().split(/\s+/).length);
  };

  const getSimillarityReport = async (indexId, d_key) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { similarityCheckId: indexId, d_key },
      headers: headers,
    };
    downloadSimiliratyReport(queryParams);
  };

  const handleReadMore = (idx) => {
    let result = [...showReadMore];
    result[idx] = !result[idx];
    setShowReadMore(result);
  };
  const handledownloadWordArticleFun = async (headers, params) => {
    return axios.get(`${SERVER_URL}/AakashGanga/downloadWordFileArticle`, {

      headers,
      params,
      responseType: "blob", // Ensure the response is in binary format (blob)
    });
  };
  const handledownloadWordArticle = async (articleId) => {
    try {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const params = {
        userId: userId,
        articleId: articleId,
      };

      const response = await handledownloadWordArticleFun(headers, params);

      if (response.status === 200) {
        // Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a hidden link element to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "article.docx"); // Set a filename for the downloaded file
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up: remove the link and revoke the object URL
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        return toast.error("Please try again!!");
      }
    } catch (error) {
      console.error("Error downloading document:", error);
      return toast.error("An error occurred while downloading the document!");
    }
  };

  const handlePublishArticle = async (_id, peId, status, finalPayment) => {
    setShowWorkSaved({
      articleId: _id,
      PID: peId,
      status: true,
      finalPayment: finalPayment,
    });
  };

  const publishArticleAPICall = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: articleId,
      peStatus: "published",
      peId: showWorkSaved?.PID,
    };
    const response = await acceptRejectArticle(headers, params);
    if (response?.status === 200) {
      setShowWorkSaved({
        articleId: "",
        PID: "",
        status: false,
        finalPayment: "",
      });
      navigate("/myArticle/published", { state: "published" });
    } else {
      return toast.error("Something went wrong. Please contact with admin");
    }
  };

  const handleAcceptRevision = (id) => {
    setAcceptedRevisionIds((prev) => [...prev, id]);
    toast.success("Revision accepted successfully.");
  };
  const handleDeleteArticle = (id) => {
    setArticleToDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setShowDeleteModal(false);
    dispatch({ type: "SET_LOADER", payload: true });
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = { id: articleToDeleteId };
    const response = await deleteArticleById(headers, params);
    if (response?.status === 200) {
      dispatch({ type: "SET_LOADER", payload: false });
      toast.success("Article deleted successfully");
      fetchArticleData(activeTab);
    } else {
      dispatch({ type: "SET_LOADER", payload: false });
      return toast.error("Please try again!!");
    }
  };

  useEffect(() => {
    let myArray = new Array(articleData?.length).fill(false);
    setShowReadMore(myArray);
  }, [articleData]);

  useEffect(() => {
    fetchAllGrantsData();
  }, [page]);

  const handleArticleUpdate = (article) => {
    return setArticleUpdateRequest(article);
  };

  const handleArticleNewRequest = (article) => {
    return setArticleUpdateNewVersion(article);
  };

  const handleRedirect = (e, path) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const downloadContract = (url) => {
    if (url) {
      let filename = getNameFromUrl(url);
      if (filename.includes("?")) {
        let finalFilename = filename?.split("?")[0];
        downLoadFile(url, `${finalFilename}`);
      } else {
        downLoadFile(url, `${filename}`);
      }
    }
  };
  // console.log('articleData',articleData);

  return (
    <>
      <div className="contentListBox">
        {articleData && articleData.length > 0 ? (
          articleData?.map((article, index) => {
            const isSocietyJ =
              article?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
              article?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
              article?.journaldstype === "societyArticle" ||
              article?.submissionDetail?.journalType?.journalType === "Society Journal" ||
              article?.paymentBySociety?.apcPayBySociety === true ||
              isSocietyJournalArticle(article);

            const isMegaJ = !isSocietyJ;

            const specialCharPattern = /[!@#$%^*(),.?;":{}|\u00a0]/g;
            const contentWithoutSpecialChars = () => {
              if (activeTab === "draft" || activeTab === "submit") {
                return article?.abstract?.replace(specialCharPattern, "");
              } else {
                return article?.article?.[0]?.abstract?.replace(
                  specialCharPattern,
                  ""
                );
              }
            };
            return (
              <div className="contentList">
                {activeTab === "draft" && (
                  isSocietyJ ? (
                    <>
                      <div className="contentListHead">
                        <div className="timeList">
                          <span>
                            <strong>Created On:&nbsp;</strong>
                            {article?.createdAt
                              ? getDateFormat(article?.createdAt)
                              : "--"}
                          </span>
                          <span>
                            <strong>Last Edited: &nbsp;</strong>
                            {article?.updatedAt
                              ? getDateFormat(article?.updatedAt)
                              : "--"}
                          </span>
                        </div>
                        {!isBlankSocietyArticle(article, isSocietyJ) && (
                          <div className="draftArticleWrap" style={{ paddingLeft: "100px" }}>
                            {article?.plagirismCheck === "underProcess" || article?.plagirismCheck === "notDone" ? (
                              <h2 className="successText" style={{ color: "#ff8300" }}>
                                SIMILARITY INDEX CHECK IN PROGRESS
                              </h2>
                            ) : article?.plagirismCheck === "Done" &&
                              (article?.similarityCheckPercentage ||
                                article?.similarityCheckPercentage == 0) ? (
                              article?.similarityCheckPercentage > 15 ? (
                                <h2 className="successText" style={{ color: "#BF1E2E" }}>
                                  Similarity index check not cleared - {article?.similarityCheckPercentage}%
                                </h2>
                              ) : (
                                <h2 className="successText">
                                  SUCCESSFUL SIMILARITY INDEX CHECK - {article?.similarityCheckPercentage}%
                                  <img src={active_check} alt="active-check" />
                                </h2>
                              )
                            ) : (article?.articleStatus == "Waiting for Similarity Check by Admin" && article?.stage === "adminctrl") || article?.articleStatus == "Pending System Verification" ? (
                              <h2 className="successText" style={{ color: "#ff8300" }}>
                                SIMILARITY INDEX CHECK IN PROGRESS
                              </h2>
                            ) : null}
                          </div>
                        )}
                        {isBlankSocietyArticle(article, isSocietyJ) ? (
                          <span
                            className="t-type mr-0"
                            style={{
                              color: "#167092",
                              fontWeight: "700",
                            }}
                          >
                            Article Submission Required
                          </span>
                        ) : (
                          <>
                            <span className="t-type text-transform-none mr-0 lh-sm text-center" style={{ color: "#167092" }}>
                              {article?.articleStatus ==
                                "Waiting for Similarity Check by Admin" &&
                                article?.stage !== "adminctrl" &&
                                article?.plagirismCheck !== "underProcess" ? (
                                <>
                                  <span
                                    style={{
                                      color: "#009B94",
                                      textTransform: "none",
                                      fontWeight: "700"
                                    }}
                                    className="d-block text-center pb-1 fw-semibold"
                                  >
                                    Article <span className="text-normal">is</span>{" "}
                                    Submitted
                                  </span>
                                </>
                              ) : null}
                              <span className="textOrange d-block text-center">
                                {article?.articleStatus == "New" ||
                                (article?.articleStatus == "First Revision" &&
                                  article?.submissionDetail?.journalType ===
                                  "6454a6390d88e62fa10503bf") ? (
                                  ""
                                ) : article?.articleStatus == "Waiting for Similarity Check by Admin" || article?.articleStatus == "Pending System Verification" ? (
                                  ""
                                ) : (
                                  article?.articleStatus
                                )}
                              </span>
                            </span>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    /* Mega Journal: Only show similarity index check if real article */
                    <>
                      <div className="contentListHead" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
                        <div className="timeList">
                          <span>
                            <strong>Created On:&nbsp;</strong>
                            {article?.createdAt
                              ? getDateFormat(article?.createdAt)
                              : "--"}
                          </span>
                          <span>
                            <strong>Last Edited: &nbsp;</strong>
                            {article?.updatedAt
                              ? getDateFormat(article?.updatedAt)
                              : "--"}
                          </span>
                        </div>
                        {isRealArticle(article) &&
                          (article?.plagirismCheck === "underProcess" ||
                            (article?.plagirismCheck === "Done" &&
                              (article?.similarityCheckPercentage ||
                                article?.similarityCheckPercentage === 0)) ||
                            ((article?.articleStatus == "Waiting for Similarity Check by Admin" && article?.stage === "adminctrl") ||
                              article?.articleStatus == "Pending System Verification")) && (
                          <div className="draftArticleWrap" style={{ paddingLeft: "0", marginRight: "15px" }}>
                            {article?.plagirismCheck === "underProcess" ? (
                              <h2 className="successText" style={{ color: "#ff8300" }}>
                                SIMILARITY INDEX CHECK IN PROGRESS
                              </h2>
                            ) : article?.plagirismCheck === "Done" &&
                              (article?.similarityCheckPercentage ||
                                article?.similarityCheckPercentage === 0) ? (
                              article?.similarityCheckPercentage > 15 ? (
                                <h2 className="successText" style={{ color: "#BF1E2E" }}>
                                  Similarity index check not cleared - {article?.similarityCheckPercentage}%
                                </h2>
                              ) : (
                                <h2 className="successText">
                                  SUCCESSFUL SIMILARITY INDEX CHECK - {article?.similarityCheckPercentage}%
                                  <img src={active_check} alt="active-check" />
                                </h2>
                              )
                            ) : (article?.articleStatus == "Waiting for Similarity Check by Admin" && article?.stage === "adminctrl") || article?.articleStatus == "Pending System Verification" ? (
                              <h2 className="successText" style={{ color: "#ff8300" }}>
                                SIMILARITY INDEX CHECK IN PROGRESS
                              </h2>
                            ) : null}
                          </div>
                        )}
                        <span className="t-type text-transform-none mr-0 lh-sm text-center" style={{ color: "#167092", position: "relative", right: "auto", top: "auto", marginLeft: "auto" }}>
                          {article?.articleStatus ==
                            "Waiting for Similarity Check by Admin" &&
                            article?.stage !== "adminctrl" &&
                            article?.plagirismCheck !== "underProcess" ? (
                            <>
                              <span
                                style={{
                                  color: "#009B94",
                                  textTransform: "none",
                                  fontWeight: "700"
                                }}
                                className="d-block text-center pb-1 fw-semibold"
                              >
                                Article <span className="text-normal">is</span>{" "}
                                Submitted
                              </span>
                              {(article?.profanityWordsPresent?.isPresent === true ||
                                article?.isProfaneFlagged === true ||
                                (Array.isArray(article?.profanityWordsPresent?.words) &&
                                  article?.profanityWordsPresent?.words.length > 0)) && (
                                <div
                                  style={{
                                    color: "#BF1E2E",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    marginTop: "2px",
                                    textTransform: "none",
                                  }}
                                  className="d-block text-center"
                                >
                                  Profanity Check to be Approved
                                </div>
                              )}
                            </>
                          ) : null}
                          {article?.plagirismCheck === "notDone" ||
                            article?.articleStatus === "Pending System Verification" ? (
                            article?.articleStatus === "sentForRevision" ? (
                              <div style={{ display: 'inline-block' }}>
                                Action: ARTICLE REQUIRES SECOND REVISION
                                {!acceptedRevisionIds.includes(article?._id) && (
                                  <div className="mt-2">
                                    <button
                                      className="button button-primary"
                                      style={{ width: '100%' }}
                                      onClick={() => handleAcceptRevision(article?._id)}
                                    >
                                      ACCEPT REVISION
                                    </button>
                                  </div>
                                )}
                              </div>
                            ) : article?.articleStatus == "New" || isDocUploadFailed(article) ? (
                              "Article Submission Required"
                            ) : article?.articleStatus == "Waiting for Similarity Check by Admin" || article?.articleStatus == "Pending System Verification" ? (
                              ""
                            ) : article?.articleStatus === "Similarity index check not cleared" ? (
                              ""
                            ) : (
                              article?.articleStatus
                            )
                          ) : null}
                        </span>
                      </div>
                    </>
                  )
                )}
                {activeTab === "submit" && (
                  isSocietyJ ? (
                    <>
                      <div className="contentListHead">
                        <div className="timeList">
                          <span>
                            <strong>Submitted On: &nbsp;</strong>
                            {article?.createdAt
                              ? getDateFormat(article?.createdAt)
                              : "--"}
                          </span>
                        </div>
                        <span className="t-type mr-0">
                          {article?.articleStatus === "sentForRevision" ? (
                            <div style={{ display: 'inline-block' }}>
                              <b>ACTION</b>: Article Requires Second Revision
                              {!acceptedRevisionIds.includes(article?._id) && (
                                <div className="mt-2">
                                  <button
                                    className="button button-primary"
                                    style={{ width: '100%' }}
                                    onClick={() => handleAcceptRevision(article?._id)}
                                  >
                                    ACCEPT REVISION
                                  </button>
                                </div>
                              )}
                            </div>
                          ) : article?.articleStatus == "New" ||
                            (article?.articleStatus == "First Revision" &&
                              article?.submissionDetail?.journalType ===
                              "6454a6390d88e62fa10503bf") ? (
                            "New Article: Searching for Peer Reviewer"
                          ) : article?.articleStatus === "Waiting for Similarity Check by Admin" ? (
                            ""
                          ) : (
                            article?.articleStatus
                          )}
                        </span>
                      </div>
                      <div className="draftArticleWrap" style={{ paddingLeft: "100px" }}>
                        {article?.plagirismCheck === "underProcess" || article?.plagirismCheck === "notDone" ? (
                          <h2
                            className="successText"
                            style={{ color: "#ff8300" }}
                          >
                            SIMILARITY INDEX CHECK IN PROGRESS
                          </h2>
                        ) : article?.plagirismCheck === "Done" &&
                          (article?.similarityCheckPercentage ||
                            article?.similarityCheckPercentage == 0) ? (
                          article?.similarityCheckPercentage > 15 ? (
                            <h2 className="successText" style={{ color: "#BF1E2E" }}>
                              Similarity index check not cleared - {article?.similarityCheckPercentage}%
                            </h2>
                          ) : null
                        ) : (article?.articleStatus == "Waiting for Similarity Check by Admin" && article?.stage === "adminctrl") || article?.articleStatus == "Pending System Verification" ? (
                          <h2 className="successText" style={{ color: "#ff8300" }}>
                            SIMILARITY INDEX CHECK IN PROGRESS
                          </h2>
                        ) : null}
                      </div>
                    </>
                  ) : (
                    /* Mega Journal: Only show similarity check if real article */
                    <>
                      <div className="contentListHead">
                        <div className="timeList">
                          <span>
                            <strong>Submitted On: &nbsp;</strong>
                            {article?.createdAt
                              ? getDateFormat(article?.createdAt)
                              : "--"}
                          </span>
                        </div>
                        <span className="t-type mr-0">
                          {article?.articleStatus === "sentForRevision" ? (
                            <div style={{ display: 'inline-block' }}>
                              <b>ACTION</b>: Article Requires Second Revision
                              {!acceptedRevisionIds.includes(article?._id) && (
                                <div className="mt-2">
                                  <button
                                    className="button button-primary"
                                    style={{ width: '100%' }}
                                    onClick={() => handleAcceptRevision(article?._id)}
                                  >
                                    ACCEPT REVISION
                                  </button>
                                </div>
                              )}
                            </div>
                          ) : article?.articleStatus == "New" || isDocUploadFailed(article) ? (
                            "Article Submission Required"
                          ) : article?.articleStatus === "secondReview" ? (
                            "Article Under Review"
                          ) : article?.articleStatus === "Waiting for Similarity Check by Admin" ? (
                            <div>
                              <span>Article is Submitted</span>
                              {(article?.profanityWordsPresent?.isPresent === true ||
                                article?.isProfaneFlagged === true ||
                                (Array.isArray(article?.profanityWordsPresent?.words) &&
                                  article?.profanityWordsPresent?.words.length > 0)) && (
                                  <div
                                    style={{
                                      color: "#BF1E2E",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      marginTop: "2px",
                                      textTransform: "none",
                                    }}
                                    className="d-block text-center"
                                  >
                                    Profanity Check to be Approved
                                  </div>
                                )}
                            </div>
                          ) : (
                            article?.articleStatus
                          )}
                        </span>
                      </div>
                      {isRealArticle(article) &&
                        (article?.plagirismCheck === "underProcess" ||
                          (article?.plagirismCheck === "Done" &&
                            (article?.similarityCheckPercentage ||
                              article?.similarityCheckPercentage === 0) &&
                            article?.similarityCheckPercentage > 15) ||
                          ((article?.articleStatus == "Waiting for Similarity Check by Admin" && article?.stage === "adminctrl") ||
                            article?.articleStatus == "Pending System Verification")) && (
                        <div className="draftArticleWrap" style={{ paddingLeft: "0", marginTop: "8px" }}>
                          {article?.plagirismCheck === "underProcess" ? (
                            <h2
                              className="successText"
                              style={{ color: "#ff8300" }}
                            >
                              SIMILARITY INDEX CHECK IN PROGRESS
                            </h2>
                          ) : article?.plagirismCheck === "Done" &&
                            (article?.similarityCheckPercentage ||
                              article?.similarityCheckPercentage === 0) ? (
                            article?.similarityCheckPercentage > 15 ? (
                              <h2 className="successText" style={{ color: "#BF1E2E" }}>
                                Similarity index check not cleared - {article?.similarityCheckPercentage}%
                              </h2>
                            ) : null
                          ) : (article?.articleStatus == "Waiting for Similarity Check by Admin" && article?.stage === "adminctrl") || article?.articleStatus == "Pending System Verification" ? (
                            <h2 className="successText" style={{ color: "#ff8300" }}>
                              SIMILARITY INDEX CHECK IN PROGRESS
                            </h2>
                          ) : null}
                        </div>
                      )}
                    </>
                  )
                )}
                {activeTab === "approved" && (
                  <>
                    <div className="contentListHead">
                      <div className="timeList">
                        <span>
                          <strong>Approved On:</strong>{" "}
                          {getDateFormat(article?.updatedAt)}
                        </span>
                      </div>
                    </div>
                    {article?.article?.[0]?.grantDetails?.grantStatus ===
                      "reject" &&
                      article?.grant?.[0]?.isDeleted === false && (
                        <span className="textDetailsWrap textRed">
                          Grant Application Not Accepted{" "}
                          <b
                            onClick={() => [
                              setShowReject(true),
                              setReason(
                                article?.article?.[0]?.grantDetails?.reason
                              ),
                            ]}
                          >
                            Reason
                          </b>
                        </span>
                      )}
                    {article?.grant?.[0]?.isDeleted && (
                      <span className="textDetailsWrap textRed">
                        Grant Application Not Accepted{" "}
                        <b
                          onClick={() => [
                            setShowReject(true),
                            setReason("This Grant has been deleted"),
                          ]}
                        >
                          Reason
                        </b>
                      </span>
                    )}
                    {article?.article?.[0]?.grantDetails?.grantStatus ===
                      "approved" &&
                      article?.grant?.[0]?.isDeleted === false && (
                        <span className="textDetailsWrap textGreen">
                          Grant Application Accepted
                        </span>
                      )}
                    {article?.article?.[0]?.grantDetails?.grantStatus ===
                      "pending" &&
                      article?.grant?.[0]?.isDeleted === false && (
                        <span className="textDetailsWrap textOrange">
                          Applied For Grant
                        </span>
                      )}
                  </>
                )}
                {activeTab === "rejected" && (
                  <div className="contentListHead">
                    <div className="timeList">
                      <span>
                        <strong>Rejected On:</strong>{" "}
                        {getDateFormat(article?.updatedAt)}
                      </span>
                    </div>
                  </div>
                )}
                {activeTab === "published" && (
                  <div className="contentListHead">
                    <div className="timeList">
                      <span>
                        <strong>Published On:</strong>{" "}
                        {getDateFormat(article?.createdAt)}
                      </span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'right' }}>
                      <span style={{ fontWeight: '700', color: '#0ddf61ff', fontSize: '18px', textTransform: 'uppercase' }}>
                        Congratulations
                      </span>
                      <span style={{ fontWeight: '700', color: '#ff8300', fontSize: '16px', marginTop: '2px', }}>
                        Article Published
                      </span>
                    </div>
                  </div>
                )}
                <div className="contentListMidd">
                  {article?.user?.[0]?.fullName && (
                    <div className="d-flex align-items-center mb-2">
                      <figure
                        className="me-2 mb-0"
                        style={{
                          backgroundImage: `url(${article?.user?.[0]?.profilePicture || pfp})`,
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          flexShrink: 0,
                        }}
                      ></figure>
                      <span className="fw-semibold fs-14">
                        {article?.user?.[0]?.fullName}
                      </span>
                    </div>
                  )}
                  <h2>
                    {isBlankSocietyArticle(article, isSocietyJ) ? (
                      article?.title && article?.title !== "Not started" ? (
                        <Link
                          to={`/dashboard/edit-article/${article?._id}`}
                          state={{ from: "author-dashboard", fromTab: activeTab }}
                          style={{ color: "#212529", fontWeight: "600", fontSize: "18px", textDecoration: "none" }}
                        >
                          {article?.title}
                        </Link>
                      ) : null
                    ) : isBlankMegaArticle(article, isMegaJ) ? (
                      <Link
                        to={`/dashboard/edit-article/${article?._id}`}
                        state={{ openUploadModal: true }}
                        onClick={() => {
                          sessionStorage.setItem("reupload_article_triggered", "true");
                        }}
                        style={{ color: "#212529", fontWeight: "600", fontSize: "18px", textDecoration: "none" }}
                      >
                        Please upload the article manuscript here to complete the submission process
                      </Link>
                    ) : (
                      <Link
                        to={{
                          pathname:
                            activeTab !== "published"
                              ? `/dashboard/article/${article?._id}/review-article`
                              : null,
                        }}
                        state={{
                          _id:
                            activeTab === "draft" || activeTab === "submit"
                              ? article?._id
                              : article?.articleId,
                        }}
                        onClick={
                          activeTab === "published"
                            ? (e) =>
                              handleRedirect(
                                e,
                                `/viewPublishedArticle/${article?.article?.[0]?.slug || article?.slug || article?.articleId}`
                              )
                            : null
                        }
                      >
                        {activeTab === "draft" || activeTab === "submit"
                          ? article?.title
                          : article?.article?.[0]?.title}
                      </Link>
                    )}
                  </h2>
                  {isDocUploadFailed(article) ? null : contentWithoutSpecialChars()?.split(" ").length >
                    MAX_WORDS ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          contentWithoutSpecialChars()
                            ?.split(" ")
                            ?.slice(0, MAX_WORDS)
                            .join(" ") + "....",
                      }}
                    ></p>
                  ) : (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: contentWithoutSpecialChars()
                          ?.split(" ")
                          ?.slice(0, MAX_WORDS)
                          .join(" "),
                      }}
                    ></p>
                  )}
                  <div className="footTag d-flex justify-content-start mt-3">
                    {(activeTab === "draft" || activeTab === "submit" || activeTab === "rejected") ? (
                      <>
                        {article?.submissionDetail?.journalName && (
                          <div className="t-tag-journalWrap">
                            <span className="t-tag t-tag-journal" title={article?.submissionDetail?.journalName}>
                              {article?.submissionDetail?.journalName}
                            </span>
                          </div>
                        )}
                        {article?.subjectDetail?.[0]?.subjectName && (
                          <span className="t-tag">
                            {article?.subjectDetail?.[0]?.subjectName}
                          </span>
                        )}
                        {article?.specializations?.[0]?.specialization && (
                          <span className="t-tag">
                            {article?.specializations?.[0]?.specialization}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        {article?.article?.[0]?.submissionDetail?.journalName && (
                          <div className="t-tag-journalWrap">
                            <span className="t-tag t-tag-journal" title={article?.article?.[0]?.submissionDetail?.journalName}>
                              {article?.article?.[0]?.submissionDetail?.journalName}
                            </span>
                          </div>
                        )}
                        {article?.subjectDetail?.[0]?.subjectName && (
                          <span className="t-tag">
                            {article?.subjectDetail?.[0]?.subjectName}
                          </span>
                        )}
                        {article?.specializations?.[0]?.specialization && (
                          <span className="t-tag">
                            {article?.specializations?.[0]?.specialization}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {activeTab === "approved" && (
                  <div className="contentListFoot contentListTwo d-flex justify-content-end">

                    <div className="footAction">
                      <Link
                        onClick={() => handledownloadWordArticle(article?.articleId || article?._id)}
                        className="button button-primary"
                      >
                        Download article
                      </Link>
                      {article?.user?.[0]?.nationality === "withInIndia" &&
                        article?.article?.[0]?.finalPayment === false &&
                        article?.article?.[0]?.grantDetails?.grantStatus ===
                        "pending" &&
                        article?.grant?.[0]?.isDeleted === false && (
                          <a
                            href="javascript:void(0)"
                            className="button-link"
                            onClick={() => [
                              getGrantDetailByName(
                                article?.article?.[0]?.grantDetails?.grantName
                              ),
                              setShowButton(false),
                            ]}
                          >
                            Grant Details
                          </a>
                        )}
                      {article?.user?.[0]?.nationality === "withInIndia" &&
                        article?.article?.[0]?.finalPayment === false &&
                        article?.article?.[0]?.grantDetails?.grantStatus ===
                        "approved" &&
                        article?.grant?.[0]?.isDeleted === false && (
                          <a
                            href="javascript:void(0)"
                            className="button-link"
                            onClick={() => [
                              getGrantDetailReceived(
                                article?.article?.[0]?.grantDetails?.grantName
                              ),
                              setArticleDetailData({
                                articleId: article?.article?.[0]?._id,
                                applicantName: article?.user[0]?.fullName,
                                article: article?.article?.[0]?.title,
                              }),
                            ]}
                          >
                            Grant Received
                          </a>
                        )}

                      {article?.prReview &&
                        article?.article?.[0]?.finalPayment === false && (
                          <Link
                            to={{
                              pathname: `/dashboard/article/${article?._id}/view-report`,
                            }}
                            state={{
                              _id: article?._id,
                              rejectionArticleId: article?.articleId,
                              status: activeTab,
                              title: article?.article?.[0]?.title,
                              createdAt: article?.createdAt,
                              updatedAt: article?.updatedAt,
                              reasonHandle: article?.peRejectedReason,
                              userType: "Author",
                            }}
                            className="button button-primary ms-2"
                          >
                            VIEW REPORT
                          </Link>
                        )}
                    </div>
                  </div>
                )}
                {activeTab === "draft" && (
                  <div className="contentListFoot contentListTwo d-flex justify-content-end">

                    <div className="footAction">
                      {isBlankMegaArticle(article, isMegaJ) ? (
                        <>
                          <Link
                            to={`/dashboard/edit-article/${article?._id}`}
                            state={{ openUploadModal: true }}
                            onClick={() => {
                              sessionStorage.setItem("reupload_article_triggered", "true");
                            }}
                            className="button button-primary"
                          >
                            Upload Article
                          </Link>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            Download article
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            View Article
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            Preview &amp; Submit
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ opacity: 0.5, cursor: "not-allowed", backgroundColor: "#bf1e2e", border: "1px solid #bf1e2e", pointerEvents: "none" }}
                            disabled
                          >
                            DELETE
                          </button>
                        </>
                      ) : isBlankSocietyArticle(article, isSocietyJ) ? (
                        <>
                          <Link
                            to={`/dashboard/edit-article/${article?._id}`}
                            state={{ from: "author-dashboard", fromTab: activeTab }}
                            className="button button-primary"
                          >
                            Submit article
                          </Link>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            Download article
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            View Article
                          </button>
                          <button
                            className="button button-primary ms-2"
                            style={{ backgroundColor: "#bf1e2e", border: "1px solid #bf1e2e" }}
                            onClick={() => handleDeleteArticle(article?._id)}
                          >
                            DELETE
                          </button>
                        </>
                      ) : isDocUploadFailed(article) ? (
                        <Link
                          to={`/dashboard/edit-article/${article?._id}`}
                          state={{ openUploadModal: true }}
                          onClick={() => {
                            sessionStorage.setItem("reupload_article_triggered", "true");
                          }}
                          className="button button-primary"
                        >
                          Upload Article
                        </Link>
                      ) : (
                        <>
                          <Link
                            onClick={() => handledownloadWordArticle(article?._id)}
                            className="button button-primary"
                          >
                            Download article
                          </Link>
                          {article.plagirismCheck === "Done" && !acceptedRevisionIds.includes(article?._id) &&
                            article?.plagirismCheck !== "notDone" &&
                            article?.plagirismCheck !== "underProcess" &&
                            article?.similarityCheckPercentage > "0" &&
                            article?.articleStatus !== "First Revision" ? (
                            <Link
                              onClick={() =>
                                getSimillarityReport(
                                  article.similarityCheckId,
                                  article?.d_key
                                )
                              }
                              className="button button-primary ms-2"
                            >
                              View Report
                            </Link>
                          ) : (article?.articleStatus === "First Revision" || article?.articleStatus === "sentForRevision" || article?.articleStatus === "sentForRevisionApproval") && !acceptedRevisionIds.includes(article?._id) ? (
                            <Link
                              to={{
                                pathname: `/dashboard/article/${article?._id}/view-report`,
                              }}
                              state={{
                                _id: article?._id,
                                rejectionArticleId: article?._id,
                                articleStatus: article?.articleStatus,
                                userType: "Author",
                              }}
                              className="button button-primary ms-2"
                            >
                              VIEW REPORT
                            </Link>
                          ) : null}
                          {article?.revokeCoupon?.revoked && (
                            <>
                              <Link
                                onClick={() => {
                                  setShowNotAccepted(true);
                                  // setArticleId(article?._id);
                                  // setRejectionArticleId(article?.articleId);
                                  setRevokeComments("Revoked Coupon");
                                  setReasonHandle(
                                    article?.revokeCoupon?.revokeReason
                                  );
                                  // setPrReviewReport(article?.prReview);
                                }}
                                className="button button-primary"
                              >
                                View Reason
                              </Link>
                            </>
                          )}

                          {article?.plagirismCheck === "underProcess" || article?.plagirismCheck === "notDone" ||
                            (article?.paymentBySociety?.apcPayHaveCoupon === false &&
                              article?.paymentBySociety?.apcPayBySociety === true &&
                              article?.initialPayment === false) ||
                            article?.revokeCoupon?.revoked ||
                            (article?.plagirismCheck === "done" &&
                              article?.similarityCheckPercentage < 15) ||
                            (article?.stage === "adminctrl" &&
                              article?.similarityCheckPercentage === undefined) ? (
                            <>
                              <Link
                                to={{
                                  pathname:
                                    activeTab !== "published"
                                      ? `/dashboard/article/${article?._id}/review-article`
                                      : null,
                                }}
                                state={{
                                  _id:
                                    activeTab === "draft" || activeTab === "submit"
                                      ? article?._id
                                      : article?.articleId,
                                }}
                                className="button button-primary"
                              >
                                View Article
                              </Link>
                              {((article?.articleStatus === "sentForRevision" ||
                                article?.articleStatus === "First Revision") &&
                                activeTab === "draft") &&
                                (article?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                                  article?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                                  article?.journaldstype === "societyArticle" ||
                                  article?.submissionDetail?.journalType?.journalType === "Society Journal") && (
                                  <Link
                                    to={`/dashboard/society-editor/${article?._id}/edit-article`}
                                    state={{ from: "author-dashboard", fromTab: activeTab }}
                                    className={`button button-primary ms-2 ${(article?.articleStatus === "sentForRevision" && !acceptedRevisionIds.includes(article?._id)) ? "disabled" : ""}`}
                                    style={(article?.articleStatus === "sentForRevision" && !acceptedRevisionIds.includes(article?._id)) ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                  >
                                    Edit Article
                                  </Link>
                                )}

                            </>
                          ) : (
                            <div className="d-flex align-items-center">
                              {activeTab === "draft" && (
                                <Link
                                  to={{
                                    pathname: `/dashboard/article/${article?._id}/review-article`
                                  }}
                                  state={{
                                    _id: article?._id,
                                  }}
                                  className="button button-primary mr-2"
                                >
                                  View Article
                                </Link>
                              )}
                              {article?.articleStatus === "sentForRevision" || article?.articleStatus === "First Revision" ? (
                                <>
                                  {(article?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                                    article?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                                    article?.journaldstype === "societyArticle" ||
                                    article?.submissionDetail?.journalType?.journalType === "Society Journal") && (
                                      <Link
                                        to={`/dashboard/society-editor/${article?._id}/edit-article`}
                                        state={{ from: "author-dashboard", fromTab: activeTab }}
                                        className={`button button-primary ms-2 ${(article?.articleStatus === "sentForRevision" && !acceptedRevisionIds.includes(article?._id)) ? "disabled" : ""}`}
                                        style={(article?.articleStatus === "sentForRevision" && !acceptedRevisionIds.includes(article?._id)) ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                      >
                                        Edit Article
                                      </Link>
                                    )}
                                </>
                              ) : (
                                <>
                                  {(article?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                                    article?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                                    article?.journaldstype === "societyArticle" ||
                                    article?.submissionDetail?.journalType?.journalType === "Society Journal") && (
                                    hasTitleAndDescription(article) ? (
                                      <Link
                                        to={`/dashboard/society-editor/${article?._id}/edit-article`}
                                        state={{ from: "author-dashboard", fromTab: activeTab, openTab: "articleEditor" }}
                                        className="button button-primary"
                                      >
                                        Edit Article
                                      </Link>
                                    ) : (
                                      <>
                                        <Link
                                          to={`/dashboard/edit-article/${article?._id}`}
                                          state={{ from: "author-dashboard", fromTab: activeTab }}
                                          className="button button-primary"
                                        >
                                          {article?.paymentBySociety?.apcPayHaveCoupon ===
                                            false &&
                                            article?.paymentBySociety?.apcPayBySociety ===
                                            true &&
                                            article?.initialPayment === true &&
                                            article?.title == undefined
                                            ? "Complete Submission Journey"
                                            : "Submit Article"}
                                        </Link>
                                        {article?.plagirismCheck === "Done" && (
                                          <Link
                                            to={`/dashboard/society-editor/${article?._id}/edit-article`}
                                            state={{ from: "author-dashboard", fromTab: activeTab, openTab: "articleEditor" }}
                                            className="button button-primary ms-2"
                                          >
                                            Edit Article
                                          </Link>
                                        )}
                                      </>
                                    )
                                  )}
                                </>
                              )}
                            </div>
                          )}

                          {(article?.resubmissionRequested === true || article?.article?.[0]?.resubmissionRequested === true) && (
                            <button
                              className="button button-primary ms-2"
                              onClick={() => handleReuploadArticle(article?._id || article?.article?.[0]?._id)}
                            >
                              Reupload Article
                            </button>
                          )}

                          {isMegaJ && !isArticleSubmitted(article) && !isDocUploadFailed(article) && (
                            <Link
                              to={`/perviewArticle/${article?._id || article?.articleId}`}
                              className="button button-primary ms-2"
                            >
                              Preview &amp; Submit
                            </Link>
                          )}
                          {/* {article?.plagirismCheck === "underProcess" ? null : (
                        <Link
                          to={`/dashboard/edit-article/${
                            article?.articleId ?? article?._id
                          }`}
                          className="button button-primary mr-0"
                        >
                          Edit Article
                        </Link>
                      )} */}


                          {article?.plagirismCheck?.toLowerCase() !== "done" && (
                            <button
                              className="button button-primary ms-2"
                              style={{ backgroundColor: "#bf1e2e", border: "1px solid #bf1e2e" }}
                              onClick={() => handleDeleteArticle(article?._id)}
                            >
                              DELETE
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                {activeTab === "rejected" && (
                  <div className="contentListFoot contentListTwo d-flex justify-content-end">

                    <div className="footAction">
                      <Link
                        onClick={() => handledownloadWordArticle(article?._id)}
                        className="button button-primary"
                      >
                        Download article
                      </Link>
                      <Link
                        to="#"
                        className="button button-primary"
                        onClick={() => {
                          setShowNotAccepted(true);
                          setArticleId(article?._id);
                          setRejectionArticleId(article?.articleId);
                          setReasonHandle(article?.peRejectedReason);
                          setReasonComments(
                            article?.peRejectedReasonAdditionalComment
                          );
                          setPrReviewReport(article?.prReview);
                        }}
                      >
                        VIEW REASON
                      </Link>
                    </div>
                  </div>
                )}
                {activeTab === "submit" && (
                  <div className="contentListFoot contentListTwo d-flex justify-content-end">

                    <div className="footAction">
                      {isBlankMegaArticle(article, isMegaJ) ? (
                        <>
                          <Link
                            to={`/dashboard/edit-article/${article?._id}`}
                            state={{ openUploadModal: true }}
                            onClick={() => {
                              sessionStorage.setItem("reupload_article_triggered", "true");
                            }}
                            className="button button-primary"
                          >
                            Upload Article
                          </Link>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            Download article
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            View Article
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }}
                            disabled
                          >
                            Preview &amp; Submit
                          </button>
                          <button
                            className="button button-primary ms-2 disabled"
                            style={{ opacity: 0.5, cursor: "not-allowed", backgroundColor: "#bf1e2e", border: "1px solid #bf1e2e", pointerEvents: "none" }}
                            disabled
                          >
                            DELETE
                          </button>
                        </>
                      ) : (
                        <>
                          {(article?.articleStatus === "First Revision" || article?.articleStatus === "sentForRevision") &&
                            (article?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                              article?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                              article?.journaldstype === "societyArticle" ||
                              article?.submissionDetail?.journalType?.journalType === "Society Journal") && (
                              <Link
                                to={`/dashboard/society-editor/${article?._id}/edit-article`}
                                state={{ from: "author-dashboard", fromTab: activeTab }}
                                className={`button button-primary ${(article?.articleStatus === "sentForRevision" && !acceptedRevisionIds.includes(article?._id)) ? "disabled" : ""}`}
                                style={(article?.articleStatus === "sentForRevision" && !acceptedRevisionIds.includes(article?._id)) ? { pointerEvents: "none", opacity: 0.5 } : {}}
                              >
                                Edit Article
                              </Link>
                            )}

                          {(article?.resubmissionRequested === true || article?.article?.[0]?.resubmissionRequested === true) && (
                            <button
                              className="button button-primary ms-2"
                              onClick={() => handleReuploadArticle(article)}
                            >
                              Reupload Article
                            </button>
                          )}

                          <Link
                            onClick={() => handledownloadWordArticle(article?._id || article?.article?.[0]?._id)}
                            className="button button-primary"
                          >
                            Download article
                          </Link>

                          {isMegaJ && !isArticleSubmitted(article) && !isDocUploadFailed(article) && (
                            <Link
                              to={`/perviewArticle/${article?._id || article?.articleId}`}
                              className="button button-primary ms-2"
                            >
                              Preview &amp; Submit
                            </Link>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                {activeTab === "published" && (
                  <div className="contentListFoot contentListTwo d-flex justify-content-end">
                    <div className="footAction">
                      <Dropdown className="d-inline-block me-3" style={{ marginBottom: "6px" }}>
                        <Dropdown.Toggle className="button button-primary">
                          Action
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ minWidth: "160px" }}>
                          <Dropdown.Item
                            onClick={() => {
                              setamendmentPopup(true);
                              setAmendmentArticleId(article?.articleId || article?._id);
                              setArticleName(article?.article?.[0]?.title);
                              setAuthorName(
                                article?.article?.[0]?.authorDetails
                                  ?.author?.[0]?.fullName
                              );
                              setAmendmentData(
                                article?.article?.[0]?.amendmentData
                              );
                              setJournalName(
                                article?.article?.[0]?.submissionDetail
                                  ?.journalName
                              );
                              setSubjectName(
                                article?.subjectDetail?.[0]?.subjectName
                              );
                              setNoMoreAmendment(true);
                              setNationality(article?.user?.[0]?.nationality);
                            }}
                          >
                            Add Amendment
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              handleArticleUpdate(
                                article?.article?.[0]?.updateRequest
                              );

                              handleArticleNewRequest(
                                article?.article?.[0]?.updateRequestApprove
                              );

                              {
                                article?.article?.[0]?.updateRequest &&
                                  article?.article?.[0]?.updateRequestApprove
                                  ? setShowNewArticleRequest(true)
                                  : article?.article?.[0]?.updateRequest
                                    ? setAlreadyUpdatedPopup(true)
                                    : setUpdateArticlePopup(true);
                              }
                              setUpdateArticlePopup(true);
                              setAmendmentArticleId(article?.articleId || article?._id);
                              setArticleName(article?.article?.[0]?.title);
                              setAuthorName(
                                article?.article?.[0]?.authorDetails
                                  ?.author?.[0]?.fullName
                              );
                              setJournalName(
                                article?.article?.[0]?.submissionDetail
                                  ?.journalName
                              );
                              setSubjectName(
                                article?.subjectDetail?.[0]?.subjectName
                              );
                            }}
                          >
                            Update Article
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              downloadContract(
                                article?.article?.[0]?.articleInvoice
                              );
                            }}
                            className={
                              !article?.article?.[0]?.articleInvoice &&
                              "opacity-5"
                            }
                          >
                            Article Invoice
                            <img className="ms-2" src={downloadBlue} alt="#" />
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              downloadContract(
                                article?.article?.[0]?.contractLink
                              );
                            }}
                          >
                            Article Contract
                            <img className="ms-2" src={downloadBlue} alt="#" />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      <Link
                        onClick={(e) =>
                          handleRedirect(
                            e,
                            `/viewPublishedArticle/${article?.article?.[0]?.slug || article?.slug || article?.articleId || article?._id}`
                          )
                        }
                        className="button button-primary me-3"
                      >
                        View Published Article
                      </Link>

                      <Link
                        onClick={() => handledownloadWordArticle(article?.articleId || article?._id)}
                        className="button button-primary"
                      >
                        Download article
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="tabContentWrap">
            <div className="notArticle">
              <figure>
                <img src={notyet} alt="No Article" />
              </figure>
              {activeTab === "draft" ? (
                <div className="au_draft">
                  <h2>You don’t have any drafts waiting!</h2>

                  <p>
                    It is time to write a new research article
                    <span>
                      We await strokes of your brilliance and colours of your
                      ideas, shaping the course of knowledge.
                    </span>
                  </p>
                </div>
              ) : activeTab === "submit" ? (
                <div className="au_submit">
                  <h2>No articles under review!</h2>
                  <p>
                    Yep, you heard it right. It's like a clean slate in there!
                    <span>
                      Think of this as a chance to recharge those brain cells
                      with our music{" "}
                      <u>
                        <b>playlists</b>
                      </u>
                      , or read up new ideas on our{" "}
                      <u>
                        <b>blog</b>
                      </u>
                      ...
                    </span>
                  </p>
                </div>
              ) : activeTab === "approved" ? (
                <div className="au_approved">
                  <h2>Access All approved articles here</h2>
                  <p>
                    All your published content at one central location
                    <span>
                      {" "}
                      Thank you for choosing us as your Publishing Partner. We
                      look forward to seeing your continued success...
                    </span>
                  </p>
                </div>
              ) : activeTab === "rejected" ? (
                <div className="au_rejected">
                  <h2>No rejected articles here!</h2>
                  <p>
                    Articles that do not get accepted for publishing will show
                    here
                    <span>
                      {" "}
                      Rejection is an integral part of your growth as a
                      researcher! Don't be afraid to embrace it, learn from it,
                      and come out even stronger! Happy Writing...
                    </span>
                  </p>
                </div>
              ) : activeTab === "published" ? (
                <div className="au_published">
                  <h2>No Published articles are home yet!</h2>
                  <p>
                    Your personal library showcasing your valuable contributions
                    <span>
                      {" "}
                      We take pride in your work and will always ensure it is
                      within your reach. It is a testament to your hard work and
                      dedication...😊
                    </span>
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>

      {activeTab === "draft" && totalRecords > 1 && (
        <div className="btnWrap mb-5 mt-4 text-center">
          <Link
            to={{ pathname: "/myArticle/draft" }}
            state={"draft"}
            className="button-border"
            onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            VIEW ALL DRAFTS
          </Link>
        </div>
      )}

      {activeTab === "submit" && totalRecords > 1 && (
        <div className="btnWrap mb-5 mt-4 text-center">
          <Link
            to={{ pathname: "/myArticle/submit" }}
            state={"submit"}
            className="button-border"
            onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            VIEW ALL UNDER REVIEW
          </Link>
        </div>
      )}

      {activeTab === "approved" && totalRecords > 1 && (
        <div className="btnWrap mb-5 mt-4 text-center">
          <Link
            to={{ pathname: "/myArticle/approved" }}
            state={"approved"}
            className="button-border"
            onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            VIEW ALL APPROVED
          </Link>
        </div>
      )}

      {activeTab === "rejected" && totalRecords > 1 && (
        <div className="btnWrap mb-5 mt-4 text-center">
          <Link
            to={{ pathname: "/myArticle/rejected" }}
            state={"rejected"}
            className="button-border"
            onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            VIEW ALL REJECTED
          </Link>
        </div>
      )}

      {activeTab === "published" && totalRecords > 1 && (
        <div className="btnWrap mb-5 mt-4 text-center">
          <Link
            to={{ pathname: "/myArticle/published" }}
            state={"published"}
            className="button-border"
            onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            VIEW ALL PUBLISHED
          </Link>
        </div>
      )}
      <Modal
        show={availableGrants}
        size="sm"
        id="unicheck-results__modal"
        tabIndex={-1}
        dialogClassName="right authorModal "
      >
        <Modal.Header className="customHeader">
          <h5 className="modal-title"> Available Grants</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setavailableGrants(false)}
          />
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="draftTable">
            <table className="w-100">
              <thead>
                <tr>
                  <th className="text-left">Grant Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {grantData &&
                  grantData.length > 0 &&
                  grantData?.map((data) => {
                    return (
                      <>
                        <tr className="empty">
                          <td colspan="2"></td>
                        </tr>
                        <tr>
                          <td>{data?.grantName ? data?.grantName : "--"}</td>
                          <td>
                            <a
                              href="javascript:void(0)"
                              className="readMore"
                              onClick={() => getGrantDetail(data?._id)}
                            >
                              {" "}
                              DETAILS
                            </a>
                          </td>
                        </tr>
                      </>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showDetail}
        dialogClassName="modal-dialog-centered modal-lg authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">Grant Details</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div className="grantDetails">
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b>Grant Name</b>
                  <span className="textGreen">{grantDetail?.grantName}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="infotext">
                  <b>Available For</b>
                  <span className="textGreen">{grantDetail?.availableFor}</span>
                </div>
              </div>
              <div className="col-md-3">
                <div className="infotext">
                  <b>Grant Value</b>
                  <span className="textGreen">
                    INR {grantDetail?.grantValue}
                  </span>
                </div>
              </div>
              <div className="col-md-3">
                <div className="infotext">
                  <b className="pb-2">&nbsp;</b>
                  Per Individual
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="infotext">
                  <b>Start Date</b>
                  <span className="textGreen">
                    <td> {getDateFormat(grantDetail?.createdAt)}</td>
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="infotext">
                  <b>
                    End Date
                    <div className="customTool">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p className="mb-3">
                                    The start and end dates represent the period
                                    for which the Grant is available with the
                                    platform. You can use the grant only at the
                                    time of making the final payment.
                                  </p>
                                  <p>
                                    Please note that grant maybe requested by
                                    multiple researchers at the same time.
                                    Therefore, we recommend that you make the
                                    balance payment at the earliest.
                                  </p>
                                  <p>
                                    Do note that the grant approval lapses with
                                    the lapse of your approved article should
                                    you not make the balance payment. You may be
                                    asked to reapply for the grant and it is
                                    possible the grant though made available to
                                    you now, is not available at a later date.
                                  </p>
                                  <div className="helpPopupText pb-0 pt-2">
                                    Need help? Write to us at
                                    <a href="mailto:contactus@vikramshilaedu.in">
                                      contactus@vikramshilaedu.in
                                    </a>
                                  </div>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={active_info}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                  </b>
                  <span className="textGreen">
                    <td> {getDateFormat(grantDetail?.endDate)}</td>
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b>Description</b>
                  <span className="textGreen">{grantDetail?.description}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b>Eligibility </b>
                  <span className="textGreen">{grantDetail?.eligibility}</span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="pb-4">
          {showButton === true && (
            <button
              class="button button-primary"
              onClick={() => [setShowDetail(false), setapplyGrant(true)]}
            >
              Apply For Grant
            </button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={applyGrant}
        dialogClassName="modal-dialog-centered modal-lg authorModal"
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header className="modal-header">
            <h5 className="modal-title">Grant Application</h5>
            <button
              type="button"
              className="btn-close"
              ariaLabel="Close"
              onClick={(e) => setapplyGrant(false)}
            />
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="grantDetails">
              <div className="row">
                <div className="col-md-6">
                  <div className="infotext">
                    <b>Grant Name</b>
                    <span className="textGreen">{grantDetail?.grantName}</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="infotext">
                    <b>Applicant Name</b>
                    <span className="textGreen">
                      {articleDetailData?.applicantName}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="infotext">
                    <b>Article </b>
                    <span className="textGreen">
                      {articleDetailData?.article}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="infotext">
                    <b>Proposal (word limit - 300)</b>
                    <textarea
                      className="fieldForm"
                      id="proposal"
                      name="proposal"
                      value={formData.proposal}
                      onChange={handleChangeProposal}
                    />
                    <small className="fieldError">
                      {formErrors.proposal && `${formErrors.proposal}`}
                    </small>
                  </div>
                </div>
              </div>

              {fundingStatus && (
                <div>
                  <div className="infotext">
                    <div className="knowMore">Funding Information</div>
                  </div>
                  <ul className="knowList">
                    <li>
                      <p>{fundingStatus}</p>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="pb-3">
            <button class="button button-primary" type="submit">
              Submit
            </button>
            <div class="helpPopupText mt-4">
              Need help? Write to us at
              <a href="">contactus@vikramshilaedu.in</a>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal show={show} size="md" centered>
        <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
        <Modal.Header>
          <div class="modal-icon">{/* <img src={doneSvg} alt="#" /> */}</div>
          <Modal.Title className="modal-title">
            Thank you for applying
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="grantDetails submitArticle pl-2 pr-2">
            <div className="row">
              <div className="col-md-12">
                <p>
                  Your grant application is successfully submitted. Please check
                  your mailbox for further details.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            class="button button-primary"
            onClick={() => [setShow(false), fetchArticleData(activeTab)]}
          >
            That's Great
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={received}
        onHide={""}
        dialogClassName="modal-dialog-centered modal-lg authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">
            Grant Received <img src={grant} />
          </h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={(e) => setReceived(false)}
          />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div className="grantDetails">
            <div className="row">
              <div className="col-md-6">
                <div className="infotext">
                  <b>Grant Name</b>
                  <span className="textBlue">{grantDetail?.grantName}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b>Article </b>
                  <span className="textGreen">
                    {articleDetailData?.article}
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b>Description</b>
                  <span className="textGreen">{grantDetail?.description}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b>Eligibility</b>
                  <span className="textGreen">{grantDetail?.eligibility}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="infotext">
                  <b className="knowMore">
                    Know More
                    <div className="customTool">
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Popover>
                              <Popover.Body>
                                <div className="popoverToolWrap">
                                  <p className="mb-3">
                                    The start and end dates represent the period
                                    for which the Grant is available with the
                                    platform. You can use the Grant only at the
                                    time of making the final payment.
                                  </p>
                                  <p>
                                    Please note that the Grant maybe requested
                                    by multiple researchers at the same time.
                                    Therefore, we recommend that you make the
                                    balance payment at the earliest.
                                  </p>
                                  <p>
                                    Do note that the Grant approval lapses with
                                    the lapse of your approved article should
                                    you not make the balance payment. You may be
                                    asked to reapply for the Grant and it is
                                    possible the Grant though made available to
                                    you now, is not available at a later date.
                                  </p>
                                  <div className="helpPopupText pb-0 pt-2">
                                    Need help? Write to us at
                                    <a href="mailto:contactus@vikramshilaedu.in">
                                      contactus@vikramshilaedu.in
                                    </a>
                                  </div>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <img
                            className="pe-cursor ps-1"
                            src={active_info}
                            alt="no img"
                          />
                        </OverlayTrigger>
                      ))}
                    </div>
                  </b>
                  <ul className="knowList">
                    <li>
                      <p>
                        <i>Grant Received On</i>
                        <small>{getDateFormat(grantDetail?.updatedAt)}</small>
                      </p>
                      <p>
                        <i>Valid Till</i>
                        <small>{getDateFormat(grantDetail?.endDate)}</small>
                      </p>
                      <p>
                        <i>Amount Received</i>
                        <small>INR {grantDetail?.grantValue}</small>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="pb-4">
          <button
            class="button button-primary"
            onClick={(e) => setReceived(false)}
          >
            CLOSE
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showReject}
        size="md"
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        className="md-x"
        centered
      >
        <Modal.Header>
          <Modal.Title>Grant Application Rejection Reason</Modal.Title>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setShowReject(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="reasonBg">{reason}</div>

          <span className="pt-3 d-block">
            Please revisit the Grant details for more clarity.
          </span>
        </Modal.Body>
        <Modal.Footer className="pt-0">
          <button
            className="button button-primary"
            onClick={() => setShowReject(false)}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal"
        show={showWorkSaved.status}
        id="congratsMobile"
        tabIndex={-1}
        size="md"
        className="authorModal md-x"
      >
        <Modal.Header className="modal-header">
          <div class="modal-icon"> {/* <img src={doneSvg} alt="#" /> */}</div>
          <h2 class="modal-title pl-0 pr-0">PUBLISH ARTICLE</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() =>
              setShowWorkSaved({
                articleId: "",
                PID: "",
                status: "",
                finalPayment: "",
              })
            }
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <p className="mb-1">
            We are glad you have decided to publish your article.
          </p>
          <p>We will now take you to the final payment screen.</p>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <Link
            to={{
              pathname: `/manage-payment/${showWorkSaved.articleId}`,
            }}
          >
            <button className="button button-primary" type="button">
              CONTINUE
            </button>
          </Link>
          {/* {!showWorkSaved?.finalPayment ? (
            <button
              class="button button-primary"
              onClick={() => publishArticleAPICall()}
            >
              CONTINUE
            </button>
          ) : (
            <Link
              to={{
                pathname: `/dashboard/edit-article/${showWorkSaved.articleId}`,
              }}
            >
              <button class="button button-primary">CONTINUE</button>
            </Link>
          )} */}
        </Modal.Footer>
      </Modal>

      <ReasonModal
        showNotAccepted={showNotAccepted}
        setShowNotAccepted={setShowNotAccepted}
        reasonHandle={reasonHandle}
        reasonComments={reasonComments}
        revokeComments={revokeComments}
        peActiveTab={activeTab}
        _id={articleId}
        rejectionArticleId={rejectionArticleId}
        prReviewReport={prReviewReport}
        userType="Author"
      />

      <NeedHelpModal
        showHelpModal={showHelpModal}
        setShowHelpModal={setShowHelpModal}
      />

      {amendmentData?.length >= 2 ? (
        <Modal
          size="lg"
          show={noMoreAmendment}
          id="congratsMobile"
          backdrop="static"
          tabIndex={-1}
          className="  authorModal authorModalRed"
          centered
        >
          <Modal.Header className="modal-header">
            <div className="modal-icon">
              {" "}
              <img src={alertSvg} alt="#" />
            </div>
            <h5 className="modal-title">
              Important Update for Your Research Article
            </h5>
            <button
              type="button"
              className="btn-close"
              ariaLabel="Close"
              onClick={() => setNoMoreAmendment(false)}
            ></button>
          </Modal.Header>
          <Modal.Body className="pt-0 pb-0">
            <div className="congratulationsPopup">
              <p>
                We have noticed that you have made amendments to your article on
                two occasions up to this point.
              </p>
              <p>
                In accordance with our publishing guidelines, we permit a
                maximum of two revisions.
              </p>
              <p>
                Please be aware that any further amendments to the current
                article will be considered a new version of the existing
                article. To initiate this update, please accept the button
                below, and we will send you a coupon worth{" "}
                {nationality === "withInIndia" ? "INR 5000" : "USD 250"},
                applicable against the current publishing price of a new
                article.
              </p>
              <p>
                We acknowledge the importance of honing your research, and we
                are available to assist you throughout this endeavour. By
                selecting the update option, you ensure that your article
                remains a reflection of your most recent discoveries and
                insights.
              </p>
              <div className="text-center mb-4">
                <button
                  className="button button-primary redBtn"
                  onClick={() => {
                    setNoMoreAmendment(false);
                    setUpdateArticlePopup(true);
                  }}
                >
                  Yes, I Want To Update My Article
                </button>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="pb-0 pt-0">
            <div className="helpPopupText pb-2">
              In case of any queries, please reach us at{" "}
              <a href="mailto:contactus@vikramshilaedu.in">
                contactus@vikramshilaedu.in
              </a>
            </div>
          </Modal.Footer>
        </Modal>
      ) : (
        <RequestAmmended
          amendmentPopup={amendmentPopup}
          setamendmentPopup={setamendmentPopup}
          amendmentSharingPopup={amendmentSharingPopup}
          setamendmentSharingPopup={setamendmentSharingPopup}
          amendmentArticleId={amendmentArticleId}
          amendmentData={amendmentData}
          articleName={articleName}
          authorName={authorName}
          setAmendmentUpdateTrigger={setAmendmentUpdateTrigger}
        />
      )}

      {articleUpdateRequest && articleUpdateNewVersion ? (
        <UpdateArticleRequest
          showNewArticleRequest={showNewArticleRequest}
          setShowNewArticleRequest={setShowNewArticleRequest}
          amendmentArticleId={amendmentArticleId}
        />
      ) : articleUpdateRequest === true ? (
        <UpdateArticleRequest
          alreadyUpdatedPopup={alreadyUpdatedPopup}
          setAlreadyUpdatedPopup={setAlreadyUpdatedPopup}
          amendmentArticleId={amendmentArticleId}
        />
      ) : (
        <UpdateArticleRequest
          updateArticlePopup={updateArticlePopup}
          setUpdateArticlePopup={setUpdateArticlePopup}
          updateSharingPopup={updateSharingPopup}
          setUpdateSharingPopup={setUpdateSharingPopup}
          amendmentArticleId={amendmentArticleId}
          articleName={articleName}
          authorName={authorName}
          journalName={journalName}
          subjectName={subjectName}
          setUpdateTrigger={setUpdateTrigger}
        />
      )}

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        dialogClassName="modal-dialog-centered authorModal md-x"
        className="authorModal"
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title className="modal-title">Delete Article</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4 pb-4">
          <p className="text-center fs-5 mb-0">Are you sure you want to delete this article?</p>
        </Modal.Body>
        <Modal.Footer className="modal-footer justify-content-center border-0 pb-4">
          <button
            className="button button-primary"
            style={{ minWidth: "120px" }}
            onClick={confirmDelete}
          >
            YES
          </button>
          <button
            className="button button-primary"
            style={{ backgroundColor: "#6c757d", border: "1px solid #6c757d", minWidth: "120px" }}
            onClick={() => setShowDeleteModal(false)}
          >
            CANCEL
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ArticleListing;
